// app/javascript/controllers/activity_form_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  submit(event) {
    // Laisser le navigateur faire son boulot (validation HTML5, etc.)
    // On ajoute juste un feedback immédiat pour éviter l'impression de "rien ne se passe".
    if (this.hasSubmitTarget) {
      const el = this.submitTarget
      el.disabled = true

      // Conserver le libellé d'origine pour le restaurer si Turbo annule la soumission
      if (!el.dataset.originalValue) el.dataset.originalValue = el.value
      el.value = "Enregistrement…"
      el.setAttribute("aria-busy", "true")
    }
  }

  reset() {
    if (!this.hasSubmitTarget) return
    const el = this.submitTarget
    el.disabled = false
    el.value = el.dataset.originalValue || el.value
    el.removeAttribute("aria-busy")
  }
}


